import { render, staticRenderFns } from "./tplRecordView.vue?vue&type=template&id=44ab12a9&scoped=true&"
import script from "./tplRecordView.vue?vue&type=script&lang=js&"
export * from "./tplRecordView.vue?vue&type=script&lang=js&"
import style0 from "./tplRecordView.vue?vue&type=style&index=0&id=44ab12a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ab12a9",
  null
  
)

export default component.exports